'use client'

import { Button } from '@inflow/ui/components/button'
import { Card } from '@inflow/ui/components/card'
import { cn } from '@inflow/ui/lib/utils'
import { useAtom } from 'jotai'
import { usePathname } from 'next/navigation'
import { currentSubscriberAtom } from '@/auth/state'
import { NavLink } from './NavLink'

interface FooterProps {
  hiddenRoutes?: string[]
  className?: string
}

const matchPath = (pattern: string, pathname: string) => {
  // Normalize both (strip trailing slashes except root)
  const normalize = (p: string) => (p !== '/' ? p.replace(/\/+$/, '') : p)
  const normPattern = normalize(pattern)
  const normPath = normalize(pathname)

  const patternParts = normPattern.split('/')
  const pathParts = normPath.split('/')

  if (patternParts.length !== pathParts.length) return false

  return patternParts.every((part, i) => part.startsWith(':') || part === pathParts[i])
}

const Footer = ({ hiddenRoutes = [], className }: FooterProps) => {
  const [{ data: currentSubscriber }] = useAtom(currentSubscriberAtom)
  const pathname = usePathname()
  const _year = new Date().getFullYear()

  const shouldHide = hiddenRoutes.some((pattern) => matchPath(pattern, pathname))

  if (shouldHide) return null

  return (
    <footer className={cn('mx-auto h-full w-full max-w-hero', className)}>
      <Card className="grid h-full gap-3 border-0 bg-secondary/10 p-3 text-center text-gray-z text-sm md:gap-6 md:p-6">
        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            {/* <Button
              variant="ghost"
              size="icon"
            >
              <Linkedin className="stroke-primary" />
            </Button> */}
            {/* <NavLink href="/research">
              <Button
                size="sm"
                variant="link"
              >
                Research
              </Button>
            </NavLink> */}
            {currentSubscriber?.id ? (
              <NavLink href="/subscriber">
                <Button
                  size="sm"
                  variant="link"
                >
                  Account
                </Button>
              </NavLink>
            ) : (
              <NavLink href="/login">
                <Button
                  size="sm"
                  variant="link"
                >
                  Login
                </Button>
              </NavLink>
            )}
          </div>
          <NavLink href="/contact">
            <Button
              size="sm"
              variant="default"
            >
              Join
            </Button>
          </NavLink>
        </div>

        <p className="text-justify text-[8px] text-secondary">
          This website and the information contained herein are provided for informational and
          educational purposes only. The views and analysis expressed by Minack Advisors do not
          constitute investment advice, a recommendation, an offer to sell, or a solicitation to buy
          any financial product or security. Minack Advisors provides independent macroeconomic
          research and commentary for institutional and professional investors. Before making any
          investment decisions, individuals should carefully evaluate their financial situation,
          objectives, and risk tolerance, and consider seeking advice from a licensed financial
          professional.
        </p>
        <div className='flex items-center justify-between'>

          <p className="text-justify text-[8px] text-secondary">
            Authorised Representative No. <span className="font-bold">443937</span> Minack Advisors
            Pty. Ltd. ABN: <span className="font-bold">84 163 503 044</span>
          </p>

          <a target='_blank' className='text-[8px] text-secondary' href='http://inflow.surf' rel="noopener">web by inflow</a>
        </div>
      </Card>
    </footer>
  )
}

export default Footer
